export default __webpack_public_path__ + "static/media/pado.90b9ad75.png";